export default __webpack_public_path__ + "static/media/book.c5b5826e.jpg";